import { Pageable, ResponseModel } from "./app.model";
import { Session, UserRequest } from "./auth.model";
import { ExchangeItem, Flight, ListService, SeatMapChange } from "./flight.model";

export enum BookingStatus {
    Reservation = 100, // Giữ chỗ
    Cancel = 200, // Huỷ
    IssueTicket = 300, //Đã xuất vé & Thanh toan
    Update = 310, // Update
    Error = 400, // lỗi
    Refund = 500, // hoàn vé
    Void = 600, // void ve
}

export enum ServiceType {
    SEAT = 3,
    SERVICE = 2,
    BAGGAGE = 1,
    BAGGAGE_FARE_RULE = 11,
    OTHER = 9,
}

export enum PaymentType {
    BOOKING = 'booking',
    SERVICE = 'service',
}

export interface BookingHistoryModel {
    BookingCommentId: number;
    OrderCode: string;
    Content: string;
    Timeline: string;
    CreatedBy: null | number;
    CreatedByCode: string;
    CreatedByName: string;
    IsComment: boolean;
    IsProcessing: boolean;
    PermissionHide: boolean;
}

export interface BookingManagementRequest extends Pageable {
    search_text: string;
    from_date?: string;
    to_date?: string;
    status: number;
    system: string;
}

export interface BookingManagementResponse {
    BookingCode: string;
    BookingExpired: string;
    BookingId: number;
    TransactionId: string;
    OrderTransactionId: string;
    BookingStatusId: number;
    BookingStatusName: string;
    ContactAddress: string;
    ContactEmail: string;
    ContactName: string;
    ContactPhone: string;
    CreatedDate: string;
    CreatedBy: number;
    CreatedByCode: string;
    CreatedByName: string;
    InternationalFee: number;
    DisplayFeeAmount: number;
    IsPaid: boolean;
    ItineraryId: number;
    SystemCode: string;
    CarrierCode: string;
    ModifiedDate: string;
    ModifiedBy: number;
    ModifiedByCode: string;
    ModifiedByName: string;
    Note: string;
    TotalAmount: number;
    Customers: BookingManagementCustomer[];
    Flights: BookingManagementFlight[];
    RowNumber: number;
    TotalRows: number;
}

export interface BookingDetailResponse {
    
}

export interface BookingManagementCustomer {
    PassengerTypeId: number;
    FirstName: string;
    LastName: string;
}

export interface BookingManagementFlight {
    FlightId: number;
    SegmentId: number;
    DepartureDate: string;
    DepartureTime: string;
    Destination: string;
    DestinationCityName: string;
    DestinationName: string;
    FareBasis: string;
    FareClass: string;
    FareType: string;
    FlightDuration: string;
    FlightNumber: string;
    OperatingCode: string;
    Origin: string;
    OriginName: string;
    OriginCityName: string;
    IsEdit: boolean;
}

export interface Customer {
    PersonOrgId: string;
    PersonOrgCode?: string;
    FamilyId: number;
    CustomerKey: string;
    FirstName: string;
    LastName: string;
    MiddleName: string;
    Age: number;
    BirthDay: string;
    Gender: string;
    Title: string;
    RelationType: string;
    WBCID: number;
    PassengerTypeId: number;
    UseInventory: boolean;
    Address: string;
    Email: string;
    Phone: string;
    IsContract: boolean;
    ParentGuestId: number;
    LoyaltyNumber: string;
    DocumentNo: string;
    ResidenceCountry: string;
    DocumentType: number;
    Citizenship: string;
    PlaceCountry: string;
    ExpirationDate: string;
    ExpirationDateStr?: string;
    BirthDayStr: string;
    SortOrder: number;
}



export interface BookingHistoryReq {
    Content: string;
    Timeline: any;
    Status: number;
    TransactionId: string;
    UserId: number;
    UserCode: string;
    UserFullName: string;
}

export interface FlightOrderModel {
    Arrivaltime: string;
    ArrivalDate: string;
    Cabin: string;
    CarrierCode: string;
    FlightId: number;
    SegmentId: number;
    DepartureDate: string;
    DepartureTime: string;
    Destination: string;
    DestinationCityName: string;
    DestinationCityNameEn: string;
    DestinationName: string;
    DestinationNameEn: string;
    FareBasis: string;
    FareClass: string;
    FareType: string;
    FlightDuration: string;
    FlightNumber: number;
    MarketingCode: string;
    OperatingCode: string;
    Origin: string;
    OriginName: string;
    OriginCityName: string;
    OriginCityNameEn: string;
    OriginNameEn: string;
    IsEdit: boolean;
    CountFlightDetail: string;
    BookingFee: number;
    SegmentKey: string;
    IsChecked?: boolean;
}

export interface FlightDetailsOrderModel {
    AirCraftDescription: string;
    AirCraftType: string;
    Arrivaltime: string;
    Cabin: string;
    CarrierCode: string;
    FlightId: number;
    SegmentId: number;
    DepartureDate: string;
    DepartureTime: string;
    Destination: string;
    DestinationCityName: string;
    DestinationCityNameEn: string;
    DestinationName: string;
    DestinationNameEn: string;
    FareBasis: string;
    FareClass: string;
    FareType: string;
    FlightDuration: string;
    FlightNumber: string;
    OperatingCode: string;
    Origin: string;
    OriginName: string;
    OriginCityName: string;
    OriginCityNameEn: string;
    OriginNameEn: string;
    SystemCode: string;
    SegmentKey: string;
}

export interface FareInfosOrderModel {
    AirportFeesAmount: number;
    BookingId: number;
    CommissionAmount: number;
    DiscountAmount: number;
    FareBaseAmount: number;
    FareBasis: string;
    FareClass: string;
    FareType: string;
    InternationalFee: number;
    PassengerTypeId: number;
    SeatsRequired: number;
    TaxAmount: number;
    TotalAmount: number;
    VATAmount: number;
}

export interface CustomersOrderModel {
    BookingCustomerId: number;
    PassengerTypeId: number;
    FirstName: string;
    CustomerKey: string;
    LastName: string;
    Address: string;
    Age: number;
    FamilyId: number;
    BirthDay: string;
    Citizenship: string;
    DocumentNo: string;
    Email: string;
    ExpirationDate: Date;
    Gender: string;
    IsContact: boolean;
    LoyaltyNumber: string;
    MiddleName: string;
    ParentGuestId: number;
    PersonOrgId: string;
    Phone: string;
    PlaceCountry: string;
    ResidenceCountry: string;
    DocumentType: number;
    ExpirationDateStr?: string;
    Title: string;
}

export interface FareCharges {
    FareBaseAmount: number;
    TaxAmount: number;
    TotalAmount: number;
    VATAmount: number;
    BookingOrderId: number;
    InternationalFee: number;
    AirportFeesAmount: number;
    CommissionAmount: number;
    DiscountAmount: number;
    SeatsRequired: number;
    PassengerTypeId: number;
    FareClass: number;
    FareBasis: number;
    FareLevel: number;
    FareType: number;
    Currency: number;
    BookingFee: number;
    Sort: number;
}

export interface ServiceCharge {
    LogicalFlightId: number;
    SegmentId: number;
    ServiceAmount: number;
    VATAmount: number;
    ServiceVATAmount: number;
    CurrencyCode: string;
    ServiceType: number;
}

export interface SumCharge {
    FareCharges: FareCharges[];
    ServiceCharges: ServiceCharge[]
}

export interface TicketDetailModel {
    PersonOrgId: number;
    TicketNumber: number;
    IssueDate: string;
    OriginalTicketIssueDate: string;
    EndorsementAndRestrictions: string;
    FareString: string;
    TicketingOfficeCode: string;
    CouponDetails: string;
    AgencyLocation: string;
    AgentSine: string;
    TicketStatus: number;
    IsVoid: boolean;
}

export interface Service {
    ServiceType: number;
    ServiceName: string;
    ServiceAmount: number;
    VATAmount: number;
    TotalAmount: number;
    FlightServices: FlightService[];
}

export interface FlightService {
    Origin: string;
    OriginName: string;
    OriginCityName: string;
    Destination: string;
    DestinationName: string;
    DestinationCityName: string;
    ServicePaxs: ServicePax[];
}


export interface ServicePax {
    Key: string;
    FullName: string;
    ValueName: string;
}

export interface BookingOrderModel {
    BookingCode: string;
    BookingDate: string;
    BookingExpired: string;
    BookingId: number;
    TransactionId: string;
    BookingStatusId: number;
    BookingStatusName: string;
    CarrierCode: string;
    CarrierName: string;
    ContactAddress: string;
    ContactEmail: string;
    ContactName: string;
    ContactPhone: string;
    International: boolean;
    CreatedDate: string;
    CreatedBy: number;
    CreatedByCode: string;
    CreatedByName: string;
    InternationalFee: string;
    IsPaid: boolean;
    IsVoid: boolean;
    IsRefund: boolean;
    ItineraryId: number;
    Seats: BookingDetailSeat[];
    SystemCode: string;
    TicketNumber: string;
    TimePurchase: string;
    ModifiedDate: string;
    ModifiedBy: number;
    ModifiedByCode: string;
    ModifiedByName: string;
    Note: string;
    TrackId: string;
    TotalAmount: number;
    UnPaidAmount: number;
    IsEdit: boolean;
    DisplayFeeAmount: number;
    OperatingCode: string;
    TotalBookingFee: number;
    BookingCodeNDC: string;
    Attribute: Attribute;
    Services: Service[];
    Tickets: TicketDetailModel[];
    Flights: FlightOrderModel[];
    FlightDetails: FlightDetailsOrderModel[];
    FareInfos: FareInfosOrderModel[];
    Customers: CustomersOrderModel[];
    SumCharge: SumCharge;
    Baggages: BookingDetailBaggage[];
    Origin: Origin;
    Destination: Destination;
}

export interface Attribute {
    ListSK: ListSk[];
    ListOSI: ListOsi[];
    ListRemark: ListRemark[];
    ListEndorsement: ListEndorsement[];
}

export interface ListEndorsement {
    CustomerId: string;
    Endorsement: string;
    EndorsementType: number;
}

export interface ListSk {
    Index: string;
    Note: string;
    Type: string;
}

export type ListOsi = ListSk

export type ListRemark = ListSk

export type Origin = {
    Origin: string;
    OriginName: string;
    OriginCityName: string;
    OriginCityNameEn: string;
    DepartureDate: string;
}

export type Destination = {
    Destination: string;
    DestinationName: string;
    DestinationCityName: string;
    DestinationCityNameEn: string;
    DepartureDate: string;
}

export interface BookingDetailSeat
    extends Pick<BookingDetailBaggage, 'PersonOrgId' | 'FlightId' | 'SegmentId'> {
    SeatCode: string;
    SeatDescription: string;
}

export interface BookingDetailBaggage {
    PersonOrgId: string;
    FlightId: number;
    SegmentId: number;
    BaggageCode: string;
    BaggageDescription: string;
    BaggageNumber: number;
    TotalAmount: number;
    ServiceType: number;
}

export interface DeleteCommentReq {
    BookingCommentId: number;
    Status: 2;
}

export interface SyncBookingRequest {
    BookingCode: string;
    CarrierCode: string;
    SystemCode: string;
}

export interface CancelBookingRequest {
    BookingCode: string;
    CarrierCode: string;
    SystemCode: string;
}

export interface CheckPriceRequest {
    BookingCode: string;
    CarrierCode: string;
    SystemCode: string;
    UserCode: string;
}

export interface CheckPriceResponse {
    BookingCode: string;
    CarrierCode: string;
    TotalAmount: number;
    IsSuccess: boolean;
    Message: string;
    Services?: CheckPriceService[];
    FarePricings: FlightFare[];
}

export interface CheckPriceService {
    ServiceAmount: number;
    ServiceVATAmount: number;
    ServiceTotalAmount: number;
    ServiceType: number;
}


export interface FlightFare {
    TrackId: string;
    BookingClass: string;
    SystemCode: string;
    CarrierCode: string;
    LogicalFlightId: string;
    SegmentId: string;
    FareId: number;
    FareComponentId: number;
    FareTransactionId: number;
    FareClass: string;
    FareBasis: string;
    PassengerTypeId: number;
    SeatsRequired: number;
    FareBaseAmount: number;
    FareAmountInclTax: number;
    FareTotalAmount: number;
    CommissionAmount: number;
    DiscountAmount: number;
    SurChargeAmount: number;
    FareDisplayAmount: number;
    FareApplyAmount: number;
    FareSumAmount: number;
    SeatAvalible: string;
    VATAmount: number;
    AirportFeeAmount: number;
    SortOrder: number;
    FareType: string;
    FareLevel: string;
    ReturnRestrictionId: boolean;
    PricingUnitId: number;
    Currency: string;
    Cabin: string;
    CabinCode: string;
    FarePricings: FlightFare[];
    DisplayFeeAmount?: number;
}

export interface FlightService {
    Origin: string;
    OriginName: string;
    OriginCityName: string;
    Destination: string;
    DestinationName: string;
    DestinationCityName: string;
    ServicePaxs: ServicePax[];
}

export interface ChangeSeatRequest extends Omit<VoidTicketRequest, 'Tickets'> {
    TransactionId: string;
    Seats: SeatMapChange[];
}

export interface VoidTicketRequest {
    BookingCode: string;
    IPAddress: string;
    Tickets: TicketDetailModel[];
    CarrierCode: string;
    SystemCode: string;
}

export interface BookingPaymentRequest {
    BookingCode: string;
    CarrierCode: string;
    TrackId: string;
    SystemCode: string;
}

export interface BookingContactRequest {
    BookingCode: string;
    CarrierCode: string;
    Email: string;
    Name: string;
    Phone: string;
    SystemCode: string;
}

export interface BaggageChange
    extends Omit<ListService, 'Destination' | 'Origin' | 'SegmentCode' | 'name' | 'value' > {
    CustomerKey: string;
}

export interface ChangeAncillaryRequest {
    CarrierCode: string;
    TotalCustomer: number;
    TransactionId: string;
    BookingCode: string;
    Services: BaggageChange[];
    SecurityToken?: string;
    TrackId: string;
    PNRNumber: string;
    SystemCode: string;
}

export type UserInfo = Pick<Session, 'UserId' | 'UserCode' | 'IPAddress'> & {
    UserFullName: string;
};

export interface BookingStatusCurrent {
    StatusId: number;
    ID: number;
    Message: string;
}

export interface DocumentCustomerRequest
    extends Omit<VoidTicketRequest, 'Tickets'>,
        UserRequest {
    IsUpdate: boolean;
    DocumentInfos: CustomersOrderModel[];
}

export interface AddInfantRequestModel {
    CarrierCode: string;
    BookingCode: string;
    SystemCode: string;
    Infants: Pick<Customer, 'FirstName' | 'LastName' | 'Gender' | 'PassengerTypeId'>[] & {
        ParentId: string;
        Birthday: string;
    };
}

export type ChangeCustomerName = Pick<
    BookingOrderModel,
    'SystemCode' | 'CarrierCode' | 'BookingCode'
> &
    Pick<Customer, 'FirstName' | 'LastName' | 'PersonOrgId' | 'PassengerTypeId'> & {
        Exchanges?: ExchangeItem;
    };

export interface CheckChangeCustomerNameRes {
    Id: number;
    IsSuccess: boolean;
    Message: string;
    SessionData: string;
    TotalPenatyAmount: number;
    TotalDifferentAmount: number;
    Exchanges: ExchangeItem;
}

export interface UpdateCustomerInfoReq
    extends Partial<
            Pick<
                Customer,
                | 'PersonOrgId'
                | 'FamilyId'
                | 'FirstName'
                | 'LastName'
                | 'Gender'
                | 'PassengerTypeId'
                | 'LoyaltyNumber'
            >
        >,
        Partial<Pick<Customer, 'Email' | 'Address'>> {
    Birthday?: string;
    TransactionId: string;
    TrackId: string;
    CarrierCode: string;
    SystemCode: string;
    BookingCode: string;
    PhoneNumber?: string;
}

export interface SearchListFareRuleMapKeyRq {
    Origin: string;
    Destination: string;
    IsInternational: boolean;
    CountryCodeOrigin: string | null;
    CountryCodeDestination: string | null;
    FareCode?: string;
    CarrierCode?: string;
    SystemCode?: string;
}

export interface FareRuleMapKeyRes {
    Origin: string;
    Destination: string;
    Data: FareRuleMapKey[];
}

export interface FareRuleMapKey {
    IsInternational: boolean;
    AirlineName: string;
    AirlineCode: string;
    FareRules: FareRule[];
    FareCode: string[];
    MasterData: FareRuleMapKeyMasterData[];
    RowNumber: number;
}

export interface FareRule {
    FareCode: string;
    FareType: string;
    CabinCode: string;
}

export interface FareRuleMapKeyMasterData {
    CodeType: string;
    Key: string;
    KeyName: string;
    KeyNameEn: string;
    Value: string;
    InitTypeId: number;
    Description: string;
    Unit: string;
}

export interface BookingStatusCurrentParam {
    bookingCode: string;
    systemCode: string;
    carrierCode: string;
}


export interface SyncBookingResponse extends Pick<BookingOrderModel, 'TransactionId' | 'CarrierCode' | 'BookingCode'> {
    ID: number,
    Message: string,
    Status: number,
}

export interface BookingDetailSeat
    extends Pick<BookingDetailBaggage, 'PersonOrgId' | 'FlightId' | 'SegmentId'> {
    SeatCode: string;
    SeatName: string;
}
export interface SelectedFlight extends Partial<Flight> {
    Origin: string;
    Destination: string;
    FlightDate: string;
    totalSeatRequest?: number;
}

export interface Segment {
    Origin: string;
    Destination: string;
    FlightDate: string;
    CountryCodeOrigin: string,
    CountryCodeDestination: string,
    GeoCountryCodeOrigin: string,
    GeoCountryCodeDestination: string,
    IsInternational: boolean,
}

export interface MinPrice {
    SortOrder: number;
    DateSearch: string;
    DateName: string;
    FareAmount: number;
    FareIncludeFeeAmount: number;
    Carrier: string;
    AirLine: string;
    IsActive: boolean;
    IsSelect: boolean;
    Prices: any;
}

export interface SearchFlightResponse extends Segment {
    FlightData: string;
    DestinationCityName: string;
    DestinationCityNameEn: string;
    OriginCityName: string;
    OriginCityNameEn: string;
    FlightDateName: string;
    TotalSeatRequest: number;
    CabinName?: string;
    Flights: Flight[];
    MinPrice?: MinPrice;
}


export type FarePax = {
    type: number;
    totalAmount: number;
    taxAmount: number;
    FareBaseAmount: number;
    seatsRequired: number;
};

export interface CheckPriceChangeBookingRes {
    IsSuccess: boolean;
    Message: string;
    SessionData: string;
    TotalPenatyAmount: number;
    TotalDifferentAmount: number;
    Exchanges: ExchangeItem[];
}

export interface ExportBookingRequest {
    SearchText: string;
    FromDate?: string;
    ToDate?: string;
    Status: number;
    SystemCode: string;
    ExcelPageSize: number;
}

export interface VoidTicketDetailModel extends TicketDetailModel {
    Selected: boolean;
}

export interface SplitTicketCustomerModel extends Customer {
    RowNumber?: number;
    Selected: boolean;
}

export interface SplitTicketRequest extends Omit<VoidTicketRequest, 'Tickets'> {
    IPAddress: string,
    SplitPassengers: Customer[];
}

export interface SplitTicketResponse extends ResponseModel {
    TransactionId: string;
}

export type RefundTicketReq = Pick<BookingOrderModel, 'BookingCode' | 'CarrierCode' | 'TrackId'>;
    
export interface ResendEmailRequest {
    TransactionId: string;
    Email: string;
    isSendNNPNMail: boolean; // Mail hệ thống
    isSendAGMail: boolean; // Mail hãng
}

export interface AddOSIReq {
    BookingCode: string;
    SystemCode: string;
    CarrierCode: string;
    OSI: string;
}

export interface AddRemarkReq extends Omit<AddOSIReq, 'OSI'> {
    Remark: string;
}

export interface AddSKReq extends Omit<AddOSIReq, 'OSI'> {
    ListSK: ListSK[];
}

export interface ListSK {
    PersonOrgId: string;
    NoteSK: string;
    Type: string;
}

export interface AddMembershipReq extends Omit<AddOSIReq, 'OSI'> {
    Customers: Record<'PersonOrgId' | 'Membership', string>[];
}

export interface BaggagesValue {
    origin: string;
    destination: string;
    baggageDescription: BaggageLabel;
}

export interface BaggageLabel {
    handBaggage: string;
    checkBaggage: string;
}

export interface SeatValue {
    origin: string;
    destination: string;
    seatName: string;
}

export interface CustomerInfo extends CustomersOrderModel {
    baggagesValue?: BaggagesValue[];
    seatValue?: SeatValue[];
}

export interface BaggageFareRule {
    flightId: number;
    fareRule: FareRuleMapKeyMasterData[];
}

export interface BaggageBookingDetail {
    handBag: BookingDetailBaggage[];
    checkBag: BookingDetailBaggage[];
}

export type ChangeCustomerBirthday = Pick<
    BookingOrderModel,
    'SystemCode' | 'CarrierCode' | 'BookingCode'
> &
    Pick<Customer, 'PersonOrgId' | 'BirthDay'>;